import { getUser } from '@/services/user-service/user.service';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export const useUser = () => {
  const {
    data: userData,
    error,
    isFetched,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.USER(),
    queryFn: () => getUser(),
    staleTime: 5 * 60 * 1000,
  });

  return { userData, error, isFetched, isLoading, refetch };
};
